import React from 'react';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';
export function Footer() {
  return <footer id="contact" className="bg-black pt-20 pb-10 border-t border-zinc-900" data-id="element-31">
      <div className="container mx-auto px-6 md:px-12" data-id="element-32">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-33">
          {/* Brand Col */}
          <div className="lg:col-span-1" data-id="element-34">
            <div className="flex items-center gap-3 mb-6" data-id="element-35">
              <img src="https://cdn.magicpatterns.com/uploads/5czQNt9FGFzYPVyXpCNzhM/crusader-lighting-logo.jpg" alt="Crusader Lighting & Electric Logo" className="h-12 w-auto rounded-sm object-contain bg-white p-1" data-id="element-36" />
              <div className="flex flex-col" data-id="element-37">
                <span className="text-xl font-black tracking-tighter uppercase text-white" data-id="element-38">
                  Crusader
                </span>
                <span className="text-[10px] font-bold tracking-widest text-yellow-600 uppercase" data-id="element-39">
                  Lighting & Electric
                </span>
              </div>
            </div>
            <p className="text-zinc-400 text-sm leading-relaxed mb-6" data-id="element-40">
              Your trusted partner for residential and commercial electrical
              solutions. Safety, quality, and reliability in every connection.
            </p>
            <div className="flex gap-4" data-id="element-41">
              {/* Social placeholders if needed */}
            </div>
          </div>

          {/* Contact Col */}
          <div data-id="element-42">
            <h4 className="text-white font-black uppercase tracking-widest mb-6" data-id="element-43">
              Contact Us
            </h4>
            <ul className="space-y-4" data-id="element-44">
              <li data-id="element-45">
                <a href="tel:847-555-0198" className="flex items-start gap-3 text-zinc-400 hover:text-yellow-600 transition-colors group" data-id="element-46">
                  <Phone className="w-5 h-5 text-red-600 group-hover:text-yellow-600 transition-colors shrink-0" data-id="element-47" />
                  <span className="font-medium text-lg text-white group-hover:text-yellow-600 transition-colors" data-id="element-48">
                    847-555-0198
                  </span>
                </a>
              </li>
              <li className="flex items-start gap-3 text-zinc-400" data-id="element-49">
                <Mail className="w-5 h-5 text-red-600 shrink-0" data-id="element-50" />
                <span data-id="element-51">service@crusaderlighting.com</span>
              </li>
              <li className="flex items-start gap-3 text-zinc-400" data-id="element-52">
                <Clock className="w-5 h-5 text-red-600 shrink-0" data-id="element-53" />
                <div data-id="element-54">
                  <p data-id="element-55">Mon-Fri: 7:00 AM - 5:00 PM</p>
                  <p className="text-sm text-zinc-500 mt-1" data-id="element-56">
                    24/7 Emergency Service Available
                  </p>
                </div>
              </li>
            </ul>
          </div>

          {/* Service Area Col */}
          <div data-id="element-57">
            <h4 className="text-white font-black uppercase tracking-widest mb-6" data-id="element-58">
              Service Area
            </h4>
            <div className="flex items-start gap-3 text-zinc-400 mb-4" data-id="element-59">
              <MapPin className="w-5 h-5 text-red-600 shrink-0" data-id="element-60" />
              <p data-id="element-61">
                Proudly serving Des Plaines, IL and the surrounding Chicagoland
                area.
              </p>
            </div>
            <a href="https://www.google.com/maps/place/Crusader+Lighting+%26+Electrical/@42.0460847,-87.8078316,826m/data=!3m2!1e3!4b1!4m6!3m5!1s0x880fc96e30175483:0x322835c39c75a67f!8m2!3d42.0460847!4d-87.8078316!16s%2Fg%2F11ylw26y3c!18m1!1e1?entry=ttu" target="_blank" rel="noopener noreferrer" className="inline-block mt-2 text-sm font-bold uppercase tracking-widest text-yellow-600 hover:text-white transition-colors border-b border-yellow-600 hover:border-white pb-1" data-id="element-62">
              View on Google Maps
            </a>
          </div>

          {/* Quick Links Col */}
          <div data-id="element-63">
            <h4 className="text-white font-black uppercase tracking-widest mb-6" data-id="element-64">
              Quick Links
            </h4>
            <ul className="space-y-2" data-id="element-65">
              {['Home', 'Services', 'About Us', 'Reviews'].map(link => <li key={link} data-id="element-66">
                  <a href={`#${link.toLowerCase().replace(' ', '-')}`} className="text-zinc-400 hover:text-white transition-colors text-sm uppercase tracking-wider font-medium" data-id="element-67">
                    {link}
                  </a>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="border-t border-zinc-900 pt-8 flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-68">
          <p className="text-zinc-600 text-sm" data-id="element-69">
            &copy; {new Date().getFullYear()} Crusader Lighting & Electric. All
            rights reserved.
          </p>
          <p className="text-zinc-600 text-sm" data-id="element-70">IL License #123456789</p>
        </div>
      </div>
    </footer>;
}